import React from "react";
import { Users, Fuel, Snowflake, Wifi, ArrowRight } from "lucide-react";
import { FLEET } from "../mock/mock";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";

const Fleet = () => {
  return (
    <section id="fleet" className="py-20 md:py-28 bg-slate-950 text-white relative overflow-hidden">
      <div className="absolute top-0 -left-40 w-96 h-96 rounded-full bg-teal-500/10 blur-3xl" />
      <div className="absolute bottom-0 -right-40 w-96 h-96 rounded-full bg-orange-500/10 blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 backdrop-blur border border-white/20 text-white text-xs font-semibold tracking-wider uppercase">
            <span className="w-1.5 h-1.5 rounded-full bg-orange-400" /> Our Fleet
          </div>
          <h2 className="mt-4 text-3xl md:text-5xl font-bold tracking-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Choose your ride
          </h2>
          <p className="mt-4 text-slate-300 text-lg">
            From plush luxury coaches to nimble sedans — handpicked vehicles maintained to the highest standards.
          </p>
        </div>

        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {FLEET.map((v) => (
            <div
              key={v.id}
              className="group relative rounded-2xl p-6 bg-white/5 backdrop-blur border border-white/10 hover:border-orange-400/40 hover:bg-white/10 transition duration-300"
            >
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-xs font-semibold uppercase tracking-wider text-orange-300">{v.type}</div>
                  <h3 className="mt-1 text-xl font-bold text-white">{v.name}</h3>
                </div>
                <div className="text-right">
                  <div className="text-xs text-slate-400">Starting</div>
                  <div className="text-lg font-bold text-orange-300">{v.price}</div>
                </div>
              </div>

              <div className="mt-5 flex items-center gap-4 text-sm text-slate-300">
                <span className="inline-flex items-center gap-1.5">
                  <Users className="w-4 h-4 text-teal-300" /> {v.seats}
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <Snowflake className="w-4 h-4 text-teal-300" /> A/C
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <Fuel className="w-4 h-4 text-teal-300" /> Diesel
                </span>
              </div>

              <div className="mt-4 flex flex-wrap gap-1.5">
                {v.features.map((f) => (
                  <span
                    key={f}
                    className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-white/5 text-slate-300 text-[11px] font-medium border border-white/10"
                  >
                    <Wifi className="w-3 h-3" /> {f}
                  </span>
                ))}
              </div>

              <Button
                asChild
                variant="ghost"
                className="mt-5 w-full justify-between text-white bg-white/5 hover:bg-orange-500 hover:text-white group-hover:bg-orange-500"
              >
                <Link to="/contact">
                  Get Quote <ArrowRight className="w-4 h-4" />
                </Link>
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Fleet;
